/* bt-schutzraum.js, 16.09.2026, gehoert zu sections/bt-s01-schutzraum.liquid.
   Hotspots im Schnittbild, Groessen-Tabs, feste Anfrageleiste, Zaehler in den Kennzahlen,
   Film im Schnittbild auf Klick. Ohne JS bleibt die Seite lesbar: Hotspots bleiben verborgen,
   die Schichtenliste ist offen, die erste Groesse ist sichtbar. */
(function () {
  var root = document.querySelector('[data-sr]');
  if (!root) return;
  root.classList.add('is-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Hotspots und Schichten */
  var dots = root.querySelectorAll('[data-sr-dot]');
  var layers = root.querySelectorAll('[data-sr-layer]');
  function setLayer(i) {
    dots.forEach(function (d) { d.classList.toggle('is-active', d.getAttribute('data-sr-dot') === String(i)); });
    layers.forEach(function (l) {
      var on = l.getAttribute('data-sr-layer') === String(i);
      l.classList.toggle('is-active', on);
      var b = l.querySelector('button');
      if (b) b.setAttribute('aria-expanded', on ? 'true' : 'false');
    });
  }
  dots.forEach(function (d) {
    d.style.setProperty('--x', parseFloat(d.getAttribute('data-x')) + '%');
    d.style.setProperty('--y', parseFloat(d.getAttribute('data-y')) + '%');
    d.addEventListener('click', function () { setLayer(d.getAttribute('data-sr-dot')); });
  });
  layers.forEach(function (l) {
    var b = l.querySelector('button');
    if (b) b.addEventListener('click', function () { setLayer(l.getAttribute('data-sr-layer')); });
    l.addEventListener('mouseenter', function () {
      var dot = root.querySelector('[data-sr-dot="' + l.getAttribute('data-sr-layer') + '"]');
      if (dot) dot.classList.add('is-hover');
    });
    l.addEventListener('mouseleave', function () {
      dots.forEach(function (d) { d.classList.remove('is-hover'); });
    });
  });

  /* Groessen */
  var barSize = root.querySelector('[data-sr-bar-size]');
  var gewaehlt = '';
  root.querySelectorAll('[data-sr-size]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var i = tab.getAttribute('data-sr-size');
      root.querySelectorAll('[data-sr-size]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-sr-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-sr-panel') === i);
      });
      gewaehlt = tab.getAttribute('data-sr-label') || '';
      /* 18.09.2026: Preis nur mit Komma anhaengen, wenn er gepflegt ist */
      var preis = tab.getAttribute('data-sr-preis') || '';
      if (barSize) barSize.textContent = preis ? gewaehlt + ', ' + preis : gewaehlt;
    });
  });

  /* Regler Alltag und Ernstfall */
  root.querySelectorAll('[data-sr-modus]').forEach(function (box) {
    var r = box.querySelector('[data-sr-modus-range]');
    if (!r) return;
    var set = function () { box.style.setProperty('--pos', r.value + '%'); };
    r.addEventListener('input', set);
    set();
  });

  /* Ausstattungslinien */
  root.querySelectorAll('[data-sr-line]').forEach(function (tab) {
    tab.addEventListener('click', function () {
      var i = tab.getAttribute('data-sr-line');
      root.querySelectorAll('[data-sr-line]').forEach(function (t) {
        var on = t === tab;
        t.classList.toggle('is-active', on);
        t.setAttribute('aria-selected', on ? 'true' : 'false');
      });
      root.querySelectorAll('[data-sr-line-panel]').forEach(function (p) {
        p.classList.toggle('is-active', p.getAttribute('data-sr-line-panel') === i);
      });
    });
  });

  /* Anfrage vorbelegen: gewaehlte Groesse ins Infofeld, nur wenn es noch leer ist */
  root.querySelectorAll('[data-sr-cta]').forEach(function (a) {
    a.addEventListener('click', function () {
      var feld = document.querySelector('#anfrage textarea[name="contact[weitere_informationen]"]');
      var name = root.getAttribute('data-sr-name') || '';
      /* 21.09.2026 (CRO T1): Ein Knopf mit data-sr-prefill (Unterlagen anfordern) bringt seinen eigenen Text mit */
      var vorgabe = a.getAttribute('data-sr-prefill');
      if (feld && !feld.value) feld.value = vorgabe ? vorgabe + ' ' : 'Interesse: ' + name + (gewaehlt ? ', ' + gewaehlt : '') + '. ';
    });
  });

  /* Feste Kontaktleiste: sichtbar zwischen Hero und Formular. Im Scroll-Hero (18.09.2026) schon waehrend
     der Animation, als Ausstieg jederzeit erreichbar. */
  var bar = root.querySelector('[data-sr-bar]');
  var hero = root.querySelector('[data-sr-hero]');
  var form = document.getElementById('anfrage');
  if (bar && hero && 'IntersectionObserver' in window) {
    var heroSichtbar = true, formSichtbar = false;
    var immer = hero.hasAttribute('data-sr-scroll');
    /* Scroll-Hero: ausgeblendet, solange die Hero-Karte mit ihrem eigenen Anfrageknopf zu sehen ist */
    var heroKarte = immer && hero.querySelector('.bt-sr-scroll__herokarte');
    var kapLeiste = immer && hero.querySelector('.bt-sr-scroll__leiste');
    var karteSichtbar = !!heroKarte;
    /* 19.09.2026: Solange der Cookie-Hinweis (Pandectes) unten steht, bleibt die Leiste aus, sonst liegen
       beide uebereinander. Nachgeprueft wird im Sekundentakt, bis der Hinweis weg ist. */
    var cookieTakt = null;
    var cookieDa = function () {
      var c = document.querySelector('pandectes-cmp');
      if (!c) return false;
      var da = false;
      (function walk(n) {
        var kids = n.shadowRoot ? n.shadowRoot.children : n.children;
        for (var i = 0; i < kids.length && !da; i++) {
          var k = kids[i], r = k.getBoundingClientRect();
          if (r.width > 100 && r.height > 60 && r.bottom > window.innerHeight - 60) {
            var cs = getComputedStyle(k);
            if (cs.display !== 'none' && cs.visibility !== 'hidden' && cs.opacity !== '0') da = true;
          }
          walk(k);
        }
      })(c);
      return da;
    };
    var cookieStand = false;
    var update = function (ausScroll) {
      var karteDa = heroKarte && karteSichtbar && heroKarte.classList.contains('is-active');
      var cookie = ausScroll === true ? cookieStand : (cookieStand = cookieDa());
      if (cookie && !cookieTakt) cookieTakt = setInterval(update, 1000);
      if (!cookie && cookieTakt) { clearInterval(cookieTakt); cookieTakt = null; }
      var an = (immer ? !karteDa : !heroSichtbar) && !formSichtbar && !cookie;
      /* 19.09.2026: Auf niedrigen Bildschirmen (etwa 360 x 740) wuerde die Leiste die Kapitelleiste verdecken.
         Dann bleibt sie aus, bis die Kapitelleiste aus dem Bild ist. */
      if (an && kapLeiste) {
        var lr = kapLeiste.getBoundingClientRect();
        var barOben = window.innerHeight - (parseFloat(getComputedStyle(bar).bottom) || 0) - bar.offsetHeight - 8;
        if (lr.height && lr.top < window.innerHeight && lr.bottom > barOben) an = false;
      }
      bar.classList.toggle('is-visible', an);
      bar.setAttribute('aria-hidden', an ? 'false' : 'true');
      bar.querySelectorAll('a').forEach(function (link) { link.setAttribute('tabindex', an ? '0' : '-1'); });
    };
    new IntersectionObserver(function (e) { heroSichtbar = e[0].isIntersecting; update(); }).observe(hero);
    if (form) new IntersectionObserver(function (e) { formSichtbar = e[0].isIntersecting; update(); }).observe(form);
    if (kapLeiste) {
      var barTakt = false;
      window.addEventListener('scroll', function () {
        if (barTakt) return;
        barTakt = true;
        requestAnimationFrame(function () { barTakt = false; update(true); });
      }, { passive: true });
    }
    if (heroKarte) {
      new IntersectionObserver(function (e) { karteSichtbar = e[0].isIntersecting; update(); }).observe(heroKarte);
      if ('MutationObserver' in window) new MutationObserver(update).observe(heroKarte, { attributes: true, attributeFilter: ['class'] });
    }
  }

  /* Zaehler: fuehrende Zahl hochzaehlen, Rest bleibt stehen */
  var counts = root.querySelectorAll('[data-sr-count]');
  if (!reduce && counts.length && 'IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (!en.isIntersecting) return;
        io.unobserve(en.target);
        var el = en.target, txt = el.textContent, m = txt.match(/^(\s*)(\d+)(.*)$/);
        if (!m) return;
        var ziel = parseInt(m[2], 10), start = null, dauer = 900;
        var step = function (t) {
          if (!start) start = t;
          var p = Math.min((t - start) / dauer, 1);
          el.textContent = m[1] + Math.round(ziel * (1 - Math.pow(1 - p, 3))) + m[3];
          if (p < 1) requestAnimationFrame(step); else el.textContent = txt;
        };
        requestAnimationFrame(step);
      });
    }, { threshold: 0.6 });
    counts.forEach(function (c) { io.observe(c); });
  }

  /* Film im Schnittbild: laedt erst auf Klick */
  root.querySelectorAll('[data-sr-film]').forEach(function (btn) {
    btn.addEventListener('click', function () {
      var src = btn.getAttribute('data-sr-film');
      var v = document.createElement('video');
      v.src = src; v.muted = true; v.playsInline = true; v.controls = true; v.autoplay = true;
      v.className = 'bt-sr-film';
      var poster = btn.parentNode.querySelector('img');
      if (poster && btn.classList.contains('bt-sr-filmbtn--over')) poster.remove();
      btn.parentNode.replaceChild(v, btn);
      v.play && v.play();
    });
  });

  /* Scroll-Animation in Kapiteln (18.09.2026). Schaltet die Sparfassung nur um, wenn weder reduzierte
     Bewegung noch Datensparmodus gesetzt ist. Der Scrollweg besteht je Kapitel aus einer Laufstrecke
     (die Bilder bis zum Endbild des Kapitels, weich ueberblendet) und einer Haltezone, in der das
     Endbild stehen bleibt, damit man die Karte lesen kann. Geladen wird erst in Sichtnaehe, zuerst
     Bild 1. Kapitelleiste springt per Scroll, der Abspielknopf scrollt die Folge in rund 20 Sekunden. */
  var scroll = root.querySelector('[data-sr-scroll]');
  var sparen = navigator.connection && navigator.connection.saveData;
  if (scroll && !reduce && !sparen && 'IntersectionObserver' in window) (function () {
    var liste;
    try {
      liste = JSON.parse(scroll.getAttribute(window.innerWidth < 750 ? 'data-sr-frames-m' : 'data-sr-frames')) || [];
    } catch (e) { return; }
    var n = liste.length;
    if (n < 2) return;
    var track = scroll.querySelector('.bt-sr-scroll__track');
    var canvas = scroll.querySelector('.bt-sr-scroll__canvas');
    var ctx = canvas && canvas.getContext('2d');
    if (!track || !ctx) return;
    var karten = [].slice.call(scroll.querySelectorAll('.bt-sr-scroll__schritt:not(.bt-sr-scroll__herokarte)'));
    var herokarte = scroll.querySelector('.bt-sr-scroll__herokarte');
    var istHero = scroll.hasAttribute('data-sr-hero');
    /* Scroll-Hero: Bildausschnitt mit Schwerpunkt unten wie im CSS (object-position 50% 70%) */
    var FOKUS_Y = istHero ? 0.7 : 0.5;
    var knoepfe = [].slice.call(scroll.querySelectorAll('[data-sr-kap]'));
    var play = scroll.querySelector('[data-sr-play]');
    var fort = scroll.querySelector('.bt-sr-scroll__fortschritt');

    /* Zeitleiste: je Kapitel Laufstrecke in Bildern, dann HALT Einheiten Stillstand. Ohne Kapitel
       laeuft die Folge linear durch. */
    var HALT = 5, EINHEIT_VH = 8;
    var segs = [], u = 0, vorher = 0;
    karten.forEach(function (k, i) {
      var bis = Math.min(n, Math.max(1, parseInt(k.getAttribute('data-bis'), 10) || n)) - 1;
      var lauf = Math.max(0, bis - vorher);
      segs.push({ k: i, a: u, lauf: lauf, von: vorher, bis: bis, halt: u + lauf });
      u += lauf + HALT; vorher = bis;
    });
    if (!segs.length) { segs.push({ k: -1, a: 0, lauf: n - 1, von: 0, bis: n - 1, halt: n - 1 }); u = n - 1; }
    else if (vorher < n - 1) { segs.push({ k: segs[segs.length - 1].k, a: u, lauf: n - 1 - vorher, von: vorher, bis: n - 1, halt: u + n - 1 - vorher }); u += n - 1 - vorher; }
    var gesamt = Math.max(1, u);

    var bilder = new Array(n), geladen = new Array(n), stand = -1, aktivK = -2, laeuft = false;
    scroll.classList.add('is-anim');
    scroll.style.setProperty('--sr-track', Math.max(260, Math.min(900, Math.round(gesamt * EINHEIT_VH))) + 'vh');

    /* Der Shop-Kopf wird erst beim Scrollen fixiert (cdx-hd bekommt dann is-fixed). Deshalb wird
       seine Hoehe bei jedem Aktualisieren gelesen und nur bei Aenderung gesetzt. */
    var kopf = document.querySelector('.cdx-hd, header'), kopfH = -1;
    function kopfHoehe() {
      /* Scroll-Hero: feste Klebehoehe aus dem CSS (kleinste Kopfhoehe), kein Nachmessen, sonst zuckt die
         Buehne mit, waehrend der cdx-Kopf schrumpft (18.09.2026) */
      if (istHero) return;
      var h = 0;
      if (kopf) { var cs = getComputedStyle(kopf); if (cs.position === 'sticky' || cs.position === 'fixed') h = Math.max(0, Math.round(kopf.getBoundingClientRect().bottom)); }
      if (h !== kopfH) { kopfH = h; scroll.style.setProperty('--sr-top', h + 'px'); groesse(); }
    }
    function lade(i) {
      if (bilder[i]) return;
      var img = new Image();
      img.decoding = 'async';
      img.onload = function () { geladen[i] = true; zeichne(stand, true); };
      img.src = liste[i];
      bilder[i] = img;
    }
    function ladeAlle() { for (var i = 0; i < n; i++) lade(i); }
    function groesse() {
      var r = canvas.getBoundingClientRect(), d = Math.min(window.devicePixelRatio || 1, 2);
      canvas.width = Math.round(r.width * d); canvas.height = Math.round(r.height * d);
      zeichne(stand, true);
    }
    /* 22.09.2026 (Chris, Arche/Aegis): Math.min statt Math.max, das ganze Schnittbild bleibt sichtbar
       (contain statt cover). Vorher wurde bei breiten Fenstern unten abgeschnitten. */
    function malen(img, alpha) {
      var cw = canvas.width, ch = canvas.height;
      var s = Math.min(cw / img.naturalWidth, ch / img.naturalHeight);
      var w = img.naturalWidth * s, h = img.naturalHeight * s;
      ctx.globalAlpha = alpha;
      ctx.drawImage(img, (cw - w) / 2, (ch - h) * FOKUS_Y, w, h);
      ctx.globalAlpha = 1;
    }
    /* f ist die Bildposition mit Nachkommastelle. Gezeichnet wird das Bild davor, das naechste mit
       dem Nachkommaanteil darueber. Fehlt ein Bild noch, steht das letzte geladene davor. */
    function zeichne(f, erzwingen) {
      if (f < 0) return;
      var a = Math.floor(f), t = f - a;
      var j = a;
      while (j > 0 && !geladen[j]) j--;
      if (!geladen[j]) return;
      var key = j + ':' + (geladen[a + 1] ? Math.round(t * 20) : 0);
      if (!erzwingen && canvas.dataset.bild === key) return;
      /* 22.09.2026: canvas leeren, sonst bleiben bei "contain" Reste des vorherigen, groesser
         gezeichneten Bildes am Rand stehen. */
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      malen(bilder[j], 1);
      if (j === a && t > 0.02 && a + 1 < n && geladen[a + 1]) malen(bilder[a + 1], t);
      canvas.dataset.bild = key;
    }
    function weg() {
      var top = parseFloat(getComputedStyle(scroll).getPropertyValue('--sr-top')) || 0;
      return track.getBoundingClientRect().height - (window.innerHeight - top);
    }
    function anteil() {
      var w = weg();
      return w > 0 ? Math.min(1, Math.max(0, -track.getBoundingClientRect().top / w)) : 0;
    }
    function update() {
      laeuft = false;
      kopfHoehe();
      var p = anteil(), x = p * gesamt, f = 0, k = -1;
      for (var i = 0; i < segs.length; i++) {
        var s = segs[i];
        if (x <= s.halt + (i === segs.length - 1 ? Infinity : HALT) || i === segs.length - 1) {
          /* Die Karte eines Kapitels erscheint erst, wenn dessen Endbild steht. Waehrend der
             Laufstrecke bleibt die vorige Karte, vor dem ersten Kapitel steht keine. */
          k = x < s.halt ? (i > 0 ? segs[i - 1].k : -1) : s.k;
          f = x < s.halt ? s.von + (s.lauf ? (x - s.a) / s.lauf * (s.bis - s.von) : 0) : s.bis;
          break;
        }
      }
      f = Math.min(n - 1, Math.max(0, f));
      if (Math.abs(f - stand) > 0.001) { stand = f; zeichne(f, false); }
      if (k !== aktivK) {
        aktivK = k;
        karten.forEach(function (c, i) { c.classList.toggle('is-active', i === k); });
        /* Scroll-Hero: Vor dem ersten Kapitel steht die Hero-Karte mit H1, danach weicht sie. */
        if (herokarte) herokarte.classList.toggle('is-active', k === -1);
        knoepfe.forEach(function (b, i) {
          var an = i === k;
          b.classList.toggle('is-active', an);
          if (an) { b.setAttribute('aria-current', 'step'); var nav = b.parentNode; nav.scrollLeft = b.offsetLeft - (nav.clientWidth - b.offsetWidth) / 2; }
          else b.removeAttribute('aria-current');
        });
      }
      if (fort) fort.style.setProperty('--sr-fort', (p * 100).toFixed(1) + '%');
    }
    function anfordern() { if (!laeuft) { laeuft = true; requestAnimationFrame(update); } }
    function zuAnteil(p, sanft) {
      var ziel = window.scrollY + track.getBoundingClientRect().top + p * weg();
      window.scrollTo({ top: Math.round(ziel), behavior: sanft ? 'smooth' : 'auto' });
    }

    knoepfe.forEach(function (b) {
      b.addEventListener('click', function () {
        manuellPausiert = true;
        stop();
        var s = segs.filter(function (x) { return x.k === parseInt(b.getAttribute('data-sr-kap'), 10); })[0];
        if (s) zuAnteil((s.halt + 0.5) / gesamt, true);
      });
    });

    /* Abspielen: scrollt vom aktuellen Stand bis zum Ende, die ganze Folge in rund 20 Sekunden. Jede
       eigene Eingabe (Rad, Wischen, Taste, erneuter Klick) haelt an. */
    /* 22.09.2026 (Chris, Hero-Animation, Freigabe Koordination): manuellPausiert haelt fest, ob der
       Besucher selbst angehalten hat (Play-Klick, eigene Eingabe, Kapitel-Klick, Ueberspringen). Nur
       dann bleibt die Automatik beim Zurueckscrollen aus. is-fertig am Play-Knopf zeigt "Erneut
       abspielen" statt "Aufbau abspielen", siehe CSS. */
    var spielt = false, t0 = 0, p0 = 0, DAUER = 20000, manuellPausiert = false;
    function schritt(ts) {
      if (!spielt) return;
      if (!t0) t0 = ts;
      var p = p0 + (ts - t0) / (DAUER * Math.max(0.05, 1 - p0)) * (1 - p0);
      if (p >= 1) { zuAnteil(1, false); if (play) play.classList.add('is-fertig'); stop(); return; }
      zuAnteil(p, false);
      requestAnimationFrame(schritt);
    }
    function start() {
      manuellPausiert = false;
      if (play) play.classList.remove('is-fertig');
      spielt = true; t0 = 0; p0 = anteil() >= 0.99 ? 0 : anteil();
      if (play) play.setAttribute('aria-pressed', 'true');
      if (p0 === 0) zuAnteil(0, false);
      requestAnimationFrame(schritt);
    }
    function stop() { spielt = false; if (play) play.setAttribute('aria-pressed', 'false'); }
    if (play) play.addEventListener('click', function () { if (spielt) { manuellPausiert = true; stop(); } else { start(); } });
    /* Animation ueberspringen: Abspielen anhalten, der Link springt selbst hinter den Block */
    var skip = scroll.querySelector('[data-sr-skip]');
    if (skip) skip.addEventListener('click', function (e) {
      /* Selbst springen, weil das Theme Ankerklicks abfaengt und dabei den festen Kopf nicht beachtet */
      var ziel = document.getElementById((skip.getAttribute('href') || '').slice(1));
      manuellPausiert = true;
      stop();
      if (!ziel) return;
      e.preventDefault(); e.stopPropagation();
      var kopfUnten = kopf && /fixed|sticky/.test(getComputedStyle(kopf).position) ? kopf.getBoundingClientRect().bottom : 0;
      var y = window.scrollY + ziel.getBoundingClientRect().top - Math.max(kopfUnten, 140) - 16;
      window.scrollTo({ top: Math.max(0, Math.round(y)), behavior: 'auto' });
      if (ziel.focus) ziel.focus({ preventScroll: true });
    });
    ['wheel', 'touchstart', 'keydown'].forEach(function (ev) {
      window.addEventListener(ev, function (e) {
        if (!spielt) return;
        var aufKnopf = e.target && e.target.closest && e.target.closest('[data-sr-play]');
        if (aufKnopf && (ev === 'touchstart' || e.key === ' ' || e.key === 'Enter')) return;
        manuellPausiert = true;
        stop();
      }, { passive: true });
    });

    /* Im Scroll-Hero ist Bild 1 das LCP-Bild. Die uebrigen Bilder laden erst, wenn es fertig ist,
       damit sie ihm keine Bandbreite nehmen. */
    function nachLcp(fn) {
      var poster = istHero && scroll.querySelector('.bt-sr-scroll__img');
      if (!poster || poster.complete) { fn(); return; }
      poster.addEventListener('load', fn, { once: true });
      poster.addEventListener('error', fn, { once: true });
    }
    new IntersectionObserver(function (e, o) {
      if (e[0].isIntersecting) { o.disconnect(); nachLcp(ladeAlle); }
    }, { rootMargin: '150% 0px' }).observe(scroll);
    lade(0);
    /* 22.09.2026 (Chris, Hero-Animation, Freigabe Koordination): im Hero startet die Folge beim Laden
       automatisch, genau wie ein Klick auf "Aufbau abspielen". Verlaesst der Hero das Bild, pausiert
       sie (bestehende stop()). Kehrt er zurueck, laeuft sie weiter, ausser der Besucher hat selbst
       angehalten. Eigene, zusaetzliche Beobachtung, die bestehende weiter oben bleibt unveraendert. */
    if (istHero) {
      new IntersectionObserver(function (entries) {
        if (entries[0].isIntersecting) {
          if (!spielt && !manuellPausiert && anteil() < 1) start();
        } else if (spielt) {
          stop();
        }
      }, { threshold: 0.15 }).observe(scroll);
    }
    groesse(); update();
    window.addEventListener('scroll', anfordern, { passive: true });
    if (kopf) kopf.addEventListener('transitionend', anfordern);
    window.addEventListener('resize', function () { kopfHoehe(); groesse(); anfordern(); });
  })();
})();